import { Component, input, model, output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../ui/button/button';
import { SlashCircle01 } from '../../icons/slash-circle-01/slash-circle-01';
import { XClose } from '../../icons/x-close/x-close';

/** Confirmation step for destructive admin actions that are hard to undo. */
@Component({
  standalone: true,
  selector: 'app-confirm-action-dialog',
  imports: [Dialog, ButtonComponent, SlashCircle01, XClose],
  templateUrl: './confirm-action-dialog.html',
  styleUrl: './confirm-action-dialog.scss',
})
export class ConfirmActionDialog {
  isVisible = model.required<boolean>();
  title = input.required<string>();
  message = input.required<string>();
  confirmLabel = input.required<string>();

  confirmed = output<void>();
  cancelled = output<void>();

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;
}
